module.exports = __webpack_public_path__ + "static/img/11.31d97ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/11.jpg
// module id = 406
// module chunks = 1